module.exports = __webpack_public_path__ + "static/media/nodeHttp1.b19dac57.png";